import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import types from 'actions/types'
import {get} from 'lodash'
import {getPivotTableTotalReducer} from "helpers/pivotTable"

export const status = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS:
      return get(action, 'filters.status', state)
    default:
      return state
  }
}

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS:
      return get(action, 'filters.companies', state)
    default:
      return state
  }
}

export const raisedBy = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS:
      return get(action, 'filters.raisedBy', state)
    default:
      return state
  }
}

export const printedEmailed = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS:
      return get(action, 'filters.printedEmailed', state)
    default:
      return state
  }
}

export const dateTypes = (state = [], action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

const total = (state = null, action) => {
  return getPivotTableTotalReducer(state, action, purchaseOrdersPivotTableKey)
}

export const purchaseOrdersPivotTableKey = 'purchasingContext.purchaseOrders.purchaseOrders'

export default combineReducers({
  status,
  companies,
  raisedBy,
  printedEmailed,
  dateTypes,
  timeKey,
  targetStart,
  targetEnd,
  total,
  purchaseOrders: createPivotTableReducer({key: purchaseOrdersPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
})
